<!-- @veltra/icons generated sha256:c84f3c7f623345d5 gen:8 source:src/svg/normal/form-auto-complete.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormAutoComplete' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="14"
      height="8"
      x="1"
      y="4"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <path stroke="currentColor" stroke-linecap="round" stroke-width="1.2" d="M4 6v4m7-3h2m-1-1v2" />
  </svg>
</template>
